export interface UserProfile {
  id?: string;
  userId?: string;
  firstname?: string;
  lastname?: string;
  fullName?: string;
  department?: string;
  country?: string;
  company?: string;
  jobTitle?: string;
  officeLocation?: string;
  mail?: string;
  roles?: Array<string>;
  userGroupMemberships?: Array<string>;
}

export enum AzureRole {
  USER = "LFD_USER",
  Practitioner = "LEGAL_PRACTITIONER",
  M_AND_A_Practitioner = "M&A_PRACTITIONER",
  Concierge = "CONCIERGE",
  Admin = "ADMIN"
}

export enum Role {
  USER = "LFD User",
  Practitioner = "Practitioner",
  M_AND_A_Practitioner = "M&A_Practitioner",
  Concierge = "Concierge",
  Admin = "Admin"
}

export const USER_ROLES = [AzureRole.USER, AzureRole.Practitioner, AzureRole.Concierge, AzureRole.M_AND_A_Practitioner];

/** Roles permitted to raise a legal request on behalf of another person. */
export const ON_BEHALF_OF_ROLES = [
  AzureRole.Practitioner,
  AzureRole.M_AND_A_Practitioner,
  AzureRole.Concierge,
  AzureRole.Admin
];

export function canRaiseOnBehalfOf(roles?: Array<string>): boolean {
  return Array.isArray(roles) && roles.some((role) => ON_BEHALF_OF_ROLES.includes(role as AzureRole));
}

export function getUIRole(role: any) {
  if (role) {
    // Return elevated role
    if (role.includes("ADMIN")) {
      return UI_ROLE_MAP.get(AzureRole.Admin);
    } else if (role.includes("CONCIERGE")) {
      return UI_ROLE_MAP.get(AzureRole.Concierge);
    } else if (role.includes("M&A_PRACTITIONER")) {
      return UI_ROLE_MAP.get(AzureRole.M_AND_A_Practitioner);
    } else if (role.includes("LEGAL_PRACTITIONER")) {
      return UI_ROLE_MAP.get(AzureRole.Practitioner);
    } else {
      return UI_ROLE_MAP.get(AzureRole.USER);
    }
  }
}

const UI_ROLE_MAP = new Map<string, string>([
  [AzureRole.USER, Role.USER],
  [AzureRole.Practitioner, Role.Practitioner],
  [AzureRole.M_AND_A_Practitioner, Role.M_AND_A_Practitioner],
  [AzureRole.Concierge, Role.Concierge],
  [AzureRole.Admin, Role.Admin]
]);
